import './Theme/plugins/fancybox/jquery.fancybox.css';
import './Theme/css/css.css';
import './Theme/css/font-awesome-4.7.0/css/font-awesome.min.css';
import './Theme/css/animate.css';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import Header from './Header';
import Menu from './CommonMenu';
import KinhsachPageApi from './KinhsachPageApi';
import { API_URL, FILE_URL, LINK_YOUTUBE_IMAGE } from './Constants';
// import 'slick-carousel/slick/slick-theme.css'; 
import $ from 'jquery';
window.jQuery = $;
require('textillate');
require('letteringjs');
require('slick-carousel');


function KinhsachPage() {
  const [searchParams] = useSearchParams();
  const [danhmuc, setDanhmuc] = useState([]);
  const [data, setData] = useState([]);
  const catId = searchParams.get('catId');
  const title = searchParams.get('title');

  useEffect(() => {
    $('.tlt').textillate({
      loop: true,
      minDisplayTime: 20000,
      in: {
        effect: 'fadeIn',
        delayScale: 3,
        shuffle: false,
      },
      out: {
        effect: 'fadeOut',
        delayScale: 1.5,
        delay: 100,
        sync: false,
        shuffle: false,
        reverse: false,
      }
    });

    $("#sky-bg").fadeIn(2e3);

    $(".slideHomeFade").slick({
      arrows: !1,
      lazyLoad: "ondemand",
      dots: !1,
      infinite: !0,
      speed: 2e3,
      fade: !0,
      slide: "div",
      autoplay: !0,
      autoplaySpeed: 2e3,
      cssEase: "linear"
    });

    $(".slideKinhSachUpdate").slick({
      infinite: !0,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: !0,
      speed: 3e3,
      dots: !1,
      autoplaySpeed: 5e3,

      // arrows: !1,
    });

    KinhsachPageApi.getAllType().then((data) => {
      setDanhmuc(data); // Update state with the resolved data
    }).catch((error) => {
      console.error("Failed to fetch data:", error); // Handle errors
    });

    if (catId === null) {
      KinhsachPageApi.getAllData().then((data) => {
        setData(data); // Update state with the resolved data
      })
    } else {
      KinhsachPageApi.getListByCat(catId).then((data) => {
        setData(data); // Update state with the resolved data
      })
    }

    return () => {
      // Destroy Slick carousel to avoid memory leaks
      $('.slideHomeFade').slick('unslick');
      $('.slideKinhSachUpdate').slick('unslick');
    };

  }, []);
  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta httpEquiv="Content-Language" content="vi" />
      <title>Pháp Ấn Sơn | Linh Quy Pháp Ấn</title>
      <link rel="shortcut icon" href="/Upload/images/tab/logochuan.jpg" type="image/png" />
      <meta name="keywords" content="linh quy pháp ấn; linh quy phap an; Nikaya;  linhquyphapan; linhquy" />
      <meta name="description" content=" Pháp Ấn Sơn" />

      {/* <link href='https://fonts.googleapis.com/css?family=Roboto+Condensed|Open+Sans:400,700,400italic' rel='stylesheet' type='text/css'>
          <link href="/Theme/plugins/fancybox/jquery.fancybox.css" rel="stylesheet" />
          <link href="/Theme/css/css.css" rel="stylesheet"/>
          <link rel="stylesheet" href="/Theme/css/font-awesome-4.7.0/css/font-awesome.min.css">
          <link href="/Theme/css/animate.css" rel="stylesheet" />
          
          <script src="/Theme/js/jquery-1.11.2.min.js"></script> */}
      <div className="fly-text">
        <ul>
          <li className="tlt">Nguyện thành tựu</li>
          <li className="tlt">Lòng tin bất động</li>
          <li className="tlt">Nơi Đức Phật, Chánh Pháp</li>
          <li className="tlt">Chúng Tăng và Thánh Giới</li>
          <li className="tlt" />
        </ul>
      </div>
      <div id="sky-bg">
        <div className="clouds_one" />
        <div className="clouds_two" />
        <div className="clouds_three" />
      </div>
      <Header />

      <section>
        <div className="container contentContainer">
          <div className="row news-list">
            <div className="col-md-9 col-sm-9 col-xs-12">
              <Menu value={"kinhsach"} />

              <h1>{title}</h1>

              {
                catId === null ? (
                  Object.keys(data).map((category, index) => (
                    <div className="homeKinhSach" key={index}>
                      <h3>
                        <a href="#">
                          {category}
                        </a>
                      </h3>
                      <div className="row">
                        {data[category].map(item => (
                          <div className="col-md-2 col-sm-4 col-xs-6 itemHomeListVideo itemHomeListBook" href="#">
                            <div className="containerOverlay">
                              {/* <div className="iconNew">
                                <img src="/Theme/img/icon/iconNew2.png" />
                              </div> */}
                              <img className="thumbHover" alt={item.Title} title={item.Title} src={FILE_URL + item.Thumb} />
                              <div className="overlay">
                                <a className="videoHover4" href={`kinh-sach-chi-tiet?postId=${item?.id}`}>
                                  <i className="fa fa-eye "></i> Xem
                                </a>
                                <form action="/Download/File/28900?type=book" className id="formDownload-28900" method="post"><input name="__RequestVerificationToken" type="hidden" defaultValue="L7e_tpyeMdBsXC6rlvIvMyfha351r2NkstoIhMcgDPZRMLVWi6z3fiMJ9JAi8XXTOM4flhDuZ6HKxEylpwr9bC0OU9A1" />
                                  <a href={`${FILE_URL}${item?.Value}`} className="iconDonwload2 videoHover5">
                                    <i className="fa fa-download" /> Tải
                                  </a>

                                  {/* <a className="iconDonwload2 videoHover5" onclick="document.getElementById('formDownload-' + 28900).submit();">
                                    <i className="fa fa-download" /> Tải
                                  </a> */}
                                </form>
                              </div>
                            </div>
                            <a href="/kinh-sach/nghi-thuc-tu-hoc-nikaya">
                              {item.Title}
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))
                ) : (
                  data?.map((item, index) => (
                    <div className="list-news">
                      <div className="media">
                        <div className="media-left">
                          <a href={`/tin-tuc-chi-tiet/${item?.Slug_Full}?id=${item?.id}`}>
                            <img className="media-object" src={FILE_URL + item.Thumb} alt={item.Title} title={item.Title} />
                          </a>
                        </div>
                        <div className="media-body">
                          <h4 className="media-heading">
                            <a href={`/tin-tuc-chi-tiet/${item?.Slug_Full}?id=${item?.id}`}>
                              <h3 style={{ borderBottom: '2px solid #FFD21D' }}>{item.Title}</h3>
                            </a>
                          </h4>
                          {item.Description}
                          <br /><br />
                          <b>Lượt xem: {item.ViewedCount}</b>
                          <br /><br />
                          {/* <a className="videoHover4" href={`kinh-sach-chi-tiet?postId=${item?.id}`}>
                            <i className="fa fa-eye "></i> Xem
                          </a> */}
                          {/* <a href={`${FILE_URL}${item?.Value}`} className="btn btn-warning btnsize">ĐỌC SÁCH</a> */}
                          <a href={`kinh-sach-chi-tiet?postId=${item?.id}`} className="btn btn-warning btnsize">ĐỌC SÁCH</a>
                        </div>
                      </div>
                    </div>
                  ))
                )
              }

            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12 homeThongBao none-padding-left">
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12  none-padding-left  boxNews">
                  <div className="containerRightBox">
                    <h5 className="titleRightHome">DANH MỤC KINH SÁCH</h5>
                    <ul className="nav nav-pills nav-stacked listDanhMuc">
                      {danhmuc?.map((item, index) => (
                        <li>
                          <a href={`/kinh-sach?title=${item.Name}&catId=${item.Id}`}>
                            <i className="fa fa-angle-right" /> {item.Name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12   none-padding-left">
                  <a className="playlistWidget" href="/danh-sach-playlist/1">
                    <img src={require("./Theme/img/show_playlist.png")} />
                  </a>
                </div>
              </div>
              <div className="homestats">
                <h5 className="tittleHome">THỐNG KÊ</h5>
                <ul>
                  <li className="text-center">
                    <strong>Chi tiết thống kê</strong>
                  </li>
                  <li>
                    <i className="fa fa-globe" />
                    Đang truy cập: 1
                  </li>
                  <li>
                    <i className="fa fa-globe" />
                    Lượt truy cập : 8.193.200
                  </li>
                  <li>
                    <i className="fa fa-headphones" />
                    Tổng lượng nghe : 6635818
                  </li>
                  <li>
                    <i className="fa fa-download" />
                    Tổng Download : 61438
                  </li>
                  <li className="text-center">
                    <strong>Thống kê hôm nay</strong>
                  </li>
                  <li>
                    <i className="fa fa-users" />
                    Lượt truy cập hôm nay: 6
                  </li>
                  <li>
                    <i className="fa fa-cloud-download" />
                    Download trong ngày : 0
                  </li>
                  <li>
                    <i className="fa fa-user" />
                    <a href="/Noi-bo">Nội bộ</a> |
                    <a href="/Dang-xuat"><i className="icon-off" />Thoát</a>
                  </li>
                </ul>
              </div>
              <div className="homestats">
                <h5 className="tittleHome">LIÊN KẾT</h5>
                <ul>
                  <li>
                    <i className="fa fa-facebook" />
                    <a href="https://www.facebook.com/LINH-QUY-PH%C3%81P-%E1%BA%A4N-260666811038785/" target="_blank">Facebook</a>
                  </li>
                  <li>
                    <i className="fa fa-youtube" />
                    <a href="https://www.youtube.com/channel/UCnI54Nrr9AddC4pDdpIjyCg" target="_blank">YouTube</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/*// content */}
      </section>

      <footer>
        <div className="container">
          {/* <div className="_Slide3DContainer wow fadeInUp" data-wow-delay="0.4s">
            <ul className="carousel ">
              <li className="item active">
                <a href="/kinh-sach/cua-vao-bat-tu" className="itemSlide3d" tipcontent="CỬA VÀO BẤT TỬ"><img src={require("./Upload/images/z2345923129108_b9a2cd08e07aba3cab7e274c4c1896db.jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/nghi-thuc-tu-hoc-nikaya" className="itemSlide3d"><img src={require("./Upload/images/Nghi Thức Tu Học NIKAYA(1).jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/phap-hanh-nikaya-can-ban" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hy-ngot-ngao" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hien-van-an" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
            </ul>
          </div> */}
        </div>
      </footer>
      <section className="footer-copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-1">
              <img className="img-responsive" src={require("./Theme/img/linhqquylogo-small.jpg")} />
            </div>
            <div className="col-md-5">
              Copyright © 2011 - 2024<br />Linhquyphapan.vn, All right reserved <br />Chủ nhiệm: Thượng Toạ Thích Minh Thành
            </div>
            <div className="col-md-6">
              Thôn 4 - Xã Lộc Thành - Huyện Bảo Lâm - Tỉnh Lâm Đồng <br />SĐT: 0963 232 651 , 0766 522 181<br />Email: linhquyphapan@yahoo.com <br /> www.linhquyphapan.vn
            </div>
          </div>
        </div>
      </section>
      <p id="back-top" style={{ display: 'none' }}>
        <a href="#top"><span /></a>
      </p>
      <div id="fb-root" />
    </div>
  );
}

export default KinhsachPage;
